import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ResponseDto } from '../../../shared/dtos/response.dto';

export interface CancelContractDto {
    contractId: number,
    cancelAll: boolean,
    manufacturerName: string,
    field1: string,
  }

@Injectable({
    providedIn: 'root'
})
export class CancelContractService {
    public constructor(private http: HttpClient) {}

    public cancelContract(pac: string, data: CancelContractDto): Observable<ResponseDto> {
        return this.http.post<ResponseDto>(environment.outgoingRequestAPI + `Contract/${pac}/cancel`, data);
    }
}
